export default class SearchResult {
    public title: string = null;
    public description: string = null;
    public type: string = null;
    public detailsPage: string = null;
}